import React from 'react'

export default ({ message }) => (
  <div className="notification">
    <p className="notification__message">{ message }</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Global/Notification.js